"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandedRail = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ExpandedRail = ({
  position,
  inputProps,
  label,
  iconName,
  onClose,
  expandedSearchResultsView
}) => {
  return /*#__PURE__*/_react.default.createElement(_styles.IntegrationRailContainerStyle, {
    position: position
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_molecules.NavHeader, {
    showCloseIcon: true,
    label: label,
    iconName: iconName,
    onClose: onClose
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "integration-content-container"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Input, {
    className: "search-local",
    icon: "Search",
    inputProps: { ...inputProps
    },
    kind: "md",
    label: ""
  }), /*#__PURE__*/_react.default.isValidElement(expandedSearchResultsView) && expandedSearchResultsView));
};

exports.ExpandedRail = ExpandedRail;
ExpandedRail.defaultProps = {
  inputProps: {
    boxed: false,
    placeholder: 'Search'
  }
};
ExpandedRail.propTypes = {
  onClose: _propTypes.default.func,
  position: _propTypes.default.string,

  /** Integration search input props*/
  inputProps: _propTypes.default.object,
  label: _propTypes.default.string,
  iconName: _propTypes.default.string,
  expandedSearchResultsView: _propTypes.default.node
};